const layout = () => import(/* webpackChunkName: "layout" */ '@/components/layout');

export default [
  {
    path: '',
    component: layout,
    children: [
      {
        name: 'pay_onlinePayment',
        component: () => import(/* webpackChunkName: "pay_onlinePayment" */ '@/pages/pay/onlinePayment.vue'),
        meta: {
          title: '在线支付'
        },
        path: '/pay_onlinePayment/:orderSn/:tradeNo'
      },
      {
        name: 'pay_payOnBehalf',
        component: () => import(/* webpackChunkName: "pay_payOnBehalf" */ '@/pages/pay/payOnBehalf.vue'),
        meta: {
          title: '他人代付'
        },
        path: '/pay_payOnBehalf/:orderSn'
      },
    ]
  }
];
